import { cloneDeep } from "lodash";
import { UPDATE_SAVE_DIGITAL_TWIN_ERROR, UPDATE_SAVE_DIGITAL_TWIN_STARTING, UPDATE_SAVE_DIGITAL_TWIN_SUCCESS } from "../../../constants/actionTypes";
import initialState from "../../../store/initialState";

export default function saveDigitalTwinUrl(state = initialState.saveDigitalTwinUrl, action) {
    switch (action.type) {
        case UPDATE_SAVE_DIGITAL_TWIN_STARTING: {
            const newState = cloneDeep(state);
            newState.saving = true;
            newState.saved = false;
            return newState;
        }

        case UPDATE_SAVE_DIGITAL_TWIN_SUCCESS: {
            const newState = cloneDeep(state);
            newState.saving = false;
            newState.saved = true;
            newState.error = null;

            return newState;
        }

        case UPDATE_SAVE_DIGITAL_TWIN_ERROR: {
            const newState = cloneDeep(state);
            newState.saving = false;
            newState.saved = false;
            newState.error = action.err;
            return newState;
        }

        default: {
            return state;
        }
    }
}